module.exports = __webpack_public_path__ + "static/media/Insta-timelapse-1.bdc214bd.mp4";